import React from "react";
import * as S from "./styles";
import { renderColorProcurementStatus } from "../status/procurementStatusComponent";
import { renderColor } from "../status/statusCartComponent";
import { renderColorManagerPackagesStatus } from "../status/statusColorManagerPackages";
import { ProcurementStatusEnum } from "@/main/services/enum/StatusProcurement";
import TooltipComponent from "../tooltip/tooltipComponent";
import { IKogIcon } from "@/main/@types/interfaceIcons";
import {
	ReturnIcon,
	CarIcon,
	TransferredIcon,
	DeliveredIcon,
	TransitIcon,
	CancelledIcon,
	AnsweredAssignedIcon,
	AwaitingReleaseIcon,
	ReceivedIcon,
	InvoicedIcon,
	PaidIcon,
	PreQuoteIcon,
	MesaDeComprasIcon,
	PendingAnswerIcon,
	AwaitingPaymentIcon,
} from "@/main/components/shared/icons";
import AccessAlarmsIcon from "@mui/icons-material/AccessAlarms";
import { DELAYED_CARD_STATUS_KEY } from "@/main/services/constants/constantsCardStatus";
import { isNullUndefined } from "@/main/services/utils";
import { StatusCartEnum } from "@/main/services/enum/StatusCartEnum";
import { AwaitingApprovalIcon } from "@/main/components/shared/icons/awaitingApprovalIcon";

interface ICardStatus {
	idStatus: number | string;
	value: string;
	numberOfValues: number;
	isCartCardStatus?: boolean;
	onClick?: () => void;
	isManagePackages?: boolean;
	color?: string;
	icon?: React.ReactNode;
}
function KOGCardStatus({
	idStatus,
	value,
	numberOfValues,
	isCartCardStatus,
	onClick,
	isManagePackages,
	color,
	icon,
}: ICardStatus) {
	const numericIdStatus = typeof idStatus === "number" ? idStatus : 0;
	const colorFormatted =
		color ??
		(isManagePackages
			? renderColorManagerPackagesStatus(numericIdStatus)
			: isCartCardStatus
				? renderColor(numericIdStatus)
				: renderColorProcurementStatus(numericIdStatus));

	const basePropsIcon: IKogIcon = {
		height: "30px",
		width: "40px",
		color: colorFormatted,
	};

	const mapIconStatusOrderScreen: Record<number, React.ReactNode> = {
		[ProcurementStatusEnum.Assigned]: <AnsweredAssignedIcon {...basePropsIcon} />,
		[ProcurementStatusEnum.Transit]: <TransitIcon {...basePropsIcon} width="32px" />,
		[ProcurementStatusEnum.Delivered]: <DeliveredIcon {...basePropsIcon} height="30px" />,
		[ProcurementStatusEnum.Invoiced]: <InvoicedIcon {...basePropsIcon} />,
		[ProcurementStatusEnum.Paid]: <PaidIcon {...basePropsIcon} />,
		[ProcurementStatusEnum.Open]: <CarIcon {...basePropsIcon} />,
		[ProcurementStatusEnum.Cancelled]: <CancelledIcon {...basePropsIcon} width="30px" height="22px" />,
		[ProcurementStatusEnum.Received]: <ReceivedIcon {...basePropsIcon} width="30px" />,
		[ProcurementStatusEnum.PreQuote]: <PreQuoteIcon {...basePropsIcon} width="30px" />,
		[ProcurementStatusEnum.Returned]: <ReturnIcon {...basePropsIcon} width="30px" height="22px" />,
		[ProcurementStatusEnum.Transferred]: <TransferredIcon {...basePropsIcon} width="30px" height="22px" />,
		[ProcurementStatusEnum.WaitingRelease]: <AwaitingReleaseIcon {...basePropsIcon} />,
		[ProcurementStatusEnum.Manual]: <MesaDeComprasIcon {...basePropsIcon} />,
		[ProcurementStatusEnum.Closed]: null,
		[ProcurementStatusEnum.ReturnApprovalProcess]: null,
		[ProcurementStatusEnum.CancelProcess]: null,
		[ProcurementStatusEnum.ReturnProcess]: null,
		[ProcurementStatusEnum.AwaitingPayment]: <AwaitingPaymentIcon {...basePropsIcon} width="50px" height="30px" />,
		[ProcurementStatusEnum.AwaitingApproval]: <AwaitingApprovalIcon {...basePropsIcon} width="32px" height="32px" />,
	};
	const mapiconStatusPendingAnswerScreen: Record<number, React.ReactNode> = {
		[StatusCartEnum.Pending]: <PendingAnswerIcon {...basePropsIcon} />,
		[StatusCartEnum.Answered]: <AnsweredAssignedIcon {...basePropsIcon} />,
		[StatusCartEnum.Cart]: null,
	};

	const mapIconStatusByKey: Record<string, React.ReactNode> = {
		[DELAYED_CARD_STATUS_KEY]: <AccessAlarmsIcon style={{ color: colorFormatted, width: "32px", height: "32px" }} />,
	};

	const mapIconStatus = isManagePackages
		? {}
		: isCartCardStatus
			? mapiconStatusPendingAnswerScreen
			: mapIconStatusOrderScreen;
	const resolvedIcon = icon ?? mapIconStatusByKey[String(idStatus)] ?? mapIconStatus[numericIdStatus];

	return (
		<TooltipComponent placement="top" title={value}>
			<S.Container onClick={onClick} id={`id-general-card-status-${value}`}>
				<S.TitleCount $color={colorFormatted}>{numberOfValues}</S.TitleCount>
				{isNullUndefined(resolvedIcon) ? (
					<>
						<S.TitleNameStatus title={value}>{value}</S.TitleNameStatus>
						<S.Ball color={colorFormatted} />
					</>
				) : (
					<S.AreaIcon>{resolvedIcon}</S.AreaIcon>
				)}
			</S.Container>
		</TooltipComponent>
	);
}

export default KOGCardStatus;
